import {
  FeeScheduleCategoryType,
  feeScheduleCategoryTypeLabel,
} from "_shared/fee-schedules/categories/types/fee-schedule-category-type";
import Text from "_shared/text/text";

/**
 * A category's type as the redline grid and panel draw it: the word, so a change from Fee to Expense
 * reads as one word struck through and another put in, the way a name or a description does.
 */
export default class FeeScheduleCategoryTypeText extends Text {
  public static of(type: FeeScheduleCategoryType): FeeScheduleCategoryTypeText {
    return new FeeScheduleCategoryTypeText(feeScheduleCategoryTypeLabel(type));
  }

  public static override fromJSON(value: unknown): FeeScheduleCategoryTypeText | null | undefined {
    if (value === null || value === undefined) return value;
    if (typeof value !== "string") throw new Error("Cannot create FeeScheduleCategoryTypeText from non-string value");
    return new FeeScheduleCategoryTypeText(value);
  }
}
